import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-conditions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/disciplinary-conditions', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/disciplinary-conditions/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/disciplinary-conditions/${data.dis_cond_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/disciplinary-conditions/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const disciplinaryType = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-conditions/disciplinary-types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  disciplinaryType
}
